import React, {useEffect, useState} from 'react'
import {  Button,  Row, Col, Statistic, notification, Modal} from 'antd';
import mobileLogo from '../assets/logoMobile.png'
import Switch from 'react-switch';
import { AlertFilled, WarningTwoTone, ExclamationCircleOutlined, LoadingOutlined} from '@ant-design/icons';
import { GoLocation } from "react-icons/go";
import { IoIosPulse } from "react-icons/io";
import { MdLocationOff } from "react-icons/md";
import { firestore, functions, serverTimestamp, fb, projectId } from '../firebase';
import {watchPosition, stopWatchingPosition} from '../shared/utilities';
import {locationState, firestoreReadCount, userState, nativeLocationEnabledState} from '../atoms';
import moment from 'moment';
import './Checkin.css';
import { useRecoilState } from 'recoil';
import Axios from 'axios';
import CheckinFrequencyForm from '../shared/CheckinFrequencyForm'
import {Capacitor} from '@capacitor/core';
import {getCurrentPosition} from '../BackgroundGeoLocation/BackgroundGeoLocation'
import { Plugins } from '@capacitor/core';
import {APP_VERSION, APP_PLATFORM, getClientInfo} from '../shared/clientInfo';

const { Storage } = Plugins;


const { Countdown } = Statistic;
const { confirm} = Modal;

const callScheduleNotification = functions.httpsCallable('scheduleNotification');
const callClearPendingUserNotifications = functions.httpsCallable('clearPendingUserNotifications');
const callClearPendingUserEmergencyNotifications = functions.httpsCallable('clearPendingUserEmergencyNotifications');

let watchId = null;
let unsubscribeUser = null;

/* const trackLocation = ({ onSuccess, onError = () => { } }) => {
    if ('geolocation' in navigator === false) {
      return onError(new Error('Geolocation is not supported by your browser.'));
    }
  
    // Use watchPosition instead.
    return navigator.geolocation.watchPosition(onSuccess, onError);
  }; */
  

const Checkin = (props) => {
    const [checkedIn, setCheckedIn] = useState(false);
    const [timeExceeded, setTimeExceeded] = useState(false);
    const [deadline, setDeadline] = useState(null);
    const [currentUser, setCurrentUser] = useRecoilState(userState);
    const [currentLocation, setCurrentLocation] = useRecoilState(locationState);
    const [nativeLocationEnabled, setNativeLocationEnabled] = useRecoilState(nativeLocationEnabledState);
    const [readCount, setReadCount] = useRecoilState(firestoreReadCount);
    const [location, setLocation] = useState("");
    //const [locationChangedCounter, setLocationChangedCounter] = useState(0);
    const [emergencyActive, setEmergencyActive] = useState(false);
    const [showCheckinModal, setShowCheckinModal] = useState(false);
    const [deactivating, setDeactivating] = useState(false);
    const [checkingIn, setCheckingIn] = useState(false);
    const [backgroundLocationAlertShown, setBackgroundLocationAlertShown] = useState(false);
    const {startTracking, stopTracking} = props;
    
    
    
    
    useEffect(() => {
        //check if we've shown user background location info alert
        //const alertShown = localStorage.getItem('alertShown');
        const getAlertShownFromStorage = async () => {
            const alertShown = await Storage.get({key: 'alertShown'});
            if (alertShown.value === 'yes') {
                setBackgroundLocationAlertShown(true);
            } else {
            }
    
        }

        getAlertShownFromStorage();
        
       
        
    },[])
    
    useEffect(() => {
        console.log("[Checkin.js] Current User:",currentUser);
        if (currentUser.workingAlone) {
            setCheckedIn(true);
            const deadlineDate = currentUser.deadline.toDate();
            if (deadlineDate < new Date()) {
                setTimeExceeded(true);
            }
            setDeadline(moment(currentUser.deadline.toDate()));
            
        } else {
            setDeadline(null);
            setCheckedIn(false);
            setTimeExceeded(false);

        }

        if (currentUser.emergencyBeacon) {
            setEmergencyActive(true);
        } else {
            setEmergencyActive(false);
        }

        if (currentUser.emergencyBeacon || currentUser.workingAlone) {
           //don't watch position on web anymore
            /*  
            //setup watch position
            //don't watch position on Android / IOS native
            if (Capacitor.getPlatform() === 'web') {
                //web only code
                if (watchId) { stopWatchingPosition(watchId);}
                watchId = watchPosition(position => {
                    const location = {lat: position.coords.latitude, lng: position.coords.longitude };
                    console.log("Position Changed:",location);
                    // setLocation(location);
                    //setLocationChangedCounter(p => p +1);
                
                    firestore.collection('users').doc(currentUser.id).set({lastLocation: location, lastLocationUpdate: serverTimestamp()},{merge: true})
                    .then(() => { console.log("updated user location in firestore")})
                    .catch((error) => console.log("Error updating user", error.message))
                    //logActivity('checkin',location);
                },
                () => {
                    //error function  
                    console.log("Error watching position")
                },
                { 
                    throttleTime: 30000, // check position every 30 seconds
                }
                );
            } else {
                //native only code
                //startTracking();

            }  
        */
            
        }

        return(() => {
            //if (watchId) { stopWatchingPosition(watchId);}
        })
    },[currentUser])


   
    const logActivity = async (type, payload) => {
        
        if (type) {
            
            let record = {
                type: type,
                user_id: currentUser.id,
                team_id: currentUser.team_id,
                time: serverTimestamp(),
                //location: location,
                first_name: currentUser.first_name,
                last_name: currentUser.last_name,
                app_version: APP_VERSION,
                app_platform: APP_PLATFORM,
                client: getClientInfo(),
            };

            // Where the entry's location came from, for the Diagnostics column:
            // 'fresh' = a fix taken for this action, 'last_known' = that fix
            // failed or hasn't arrived yet so the previous location was reused,
            // 'none' = no location at all.
            let freshLocation = null;

            console.log("Logging Activity",record);
    
            if (type === 'checkin' || type === 'refresh') {
                console.log("Type",type);
                let expireTime;
                if (payload?.expireTime) {
                    expireTime = payload.expireTime;
                } else {
                    expireTime = deadline;
                }
                record.deadline = fb.firestore.Timestamp.fromDate(expireTime.toDate());
                record.checkin_frequency = currentUser.checkin_frequency;
                // Only add location if provided in payload for checkin/refresh
                if (payload?.location) {
                    freshLocation = payload.location;
                    console.log("location from payload", JSON.stringify(payload.location));
                } else if (currentLocation && currentLocation !== 'NONE') {
                    record.location = currentLocation;
                    console.log("currentLocation", JSON.stringify(currentLocation));
                }

            }

            if (type === 'emergencyActivate' || type === 'deactivate' || type === 'emergencyDeactivate') {
                if (payload) {
                    freshLocation = payload;
                } else if (currentLocation) {
                    record.location = currentLocation;
                }
            }

            if (freshLocation) {
                record.location = freshLocation;
                record.location_source = 'fresh';
            } else {
                record.location_source = record.location ? 'last_known' : 'none';
            }


           
            
    
            try {
                const docRef = await firestore.collection('activityLog').add(record);
                return docRef; // Return the document reference for later updates
            } catch(error) {
                console.log("Error adding ActivityLog to Firebase", error.message);
                return null;
            }
        }
        return null;
    }

    // Helper function to update an activity log entry with location
    const updateLogWithLocation = async (docRef, location) => {
        if (docRef && location) {
            try {
                await docRef.update({ location, location_source: 'fresh' });
                console.log("Updated activity log with location", location);
            } catch (error) {
                console.log("Error updating activity log with location", error.message);
            }
        }
    }

    // Helper function to get location with a timeout
    const getLocationWithTimeout = async (timeoutMs = 10000) => {
        return Promise.race([
            getCurrentPosition(),
            new Promise((_, reject) => 
                setTimeout(() => reject(new Error('Location timeout')), timeoutMs)
            )
        ]);
    }

    const confirmBeforeStart = async (action) => {
        if (backgroundLocationAlertShown === false && Capacitor.getPlatform() !== 'web') {
            Modal.warning({
                title: <div style={{textAlign:'center'}}>CoS Work Alone uses Background Geolocation</div>,
                icon: <div style={{textAlign:'center', marginBottom:20}}><img src={mobileLogo} style={{height:60}} /></div>,
                content: (<div style={{textAlign:'center'}}>
                            <p>
                                CoS Work Alone collects location data to enable the sharing of your location to your emergency contacts while working alone. It runs even when the app is closed or not in use.
                            </p>
                            <p>
                                Location data is only collected while your timer is running or your Emergency Beacon is enabled.
                            </p>
                          </div>),
                onOk() {
                    Storage.set({key: 'alertShown', value: 'yes'});
                    //localStorage.setItem('alertShown', true);
                    setBackgroundLocationAlertShown(true);
                    action();
                }
                


            })    
        } else {
            action();
        }
    }

    const startTimer = async () => {

        // Show loading state immediately for all platforms
        setCheckingIn(true);
        
        const expireTime = moment(serverTimestamp().toDate).add(currentUser.checkin_frequency, 'minutes');
        const reminderTimeInSeconds = expireTime.clone().subtract(5, 'minutes').unix();
        const expireTimeInSeconds = expireTime.clone().unix();
        const fsDeadline = fb.firestore.Timestamp.fromDate(expireTime.toDate())
        setDeadline(expireTime);
        if (Capacitor.getPlatform() !== 'web') {
            //startTracking();
            
        }
        
        
        setTimeExceeded(false);

        // Helper to schedule notifications for both Web and Mobile platforms
        const scheduleNotificationsHelper = async () => {
            let messageData = {
                payload: {
                    notificationType: 'reminder',
                    workalone_user_id: currentUser.id,
                    group_id: currentUser.group_id,
                    body: 'Your timer will expire in 5 minutes. Please check-in or deactivate', 
                    title: 'Work Alone Reminder'
                },
                deliverMessageAtSeconds: reminderTimeInSeconds
            }
            
            // ONE call, whether this is a first check-in or a renewal.
            //
            // This used to make two calls on a renewal: clearPendingUserNotifications
            // to delete the old cloud task, then scheduleNotification to create the
            // replacement. If the app died in between -- phone locked, app swiped
            // away, connection dropped -- the delete had already happened and the
            // create never did. The timer kept counting down on screen with nothing
            // scheduled behind it, and no error was raised anywhere. That is the
            // cause of the Sep 1 2026 incident.
            //
            // scheduleNotification now does the whole swap server-side, creating the
            // replacement before retiring the old task, so there is no longer any
            // window on the client that can be interrupted.
            try {
                await callScheduleNotification(messageData);
                console.log("Notification scheduled successfully");
            } catch(error) {
                console.log("CRITICAL: error scheduling notification", error);
            }
        };

        //update user in firestore once we have initial location
        const checkinLocationSuccess = async (pos) => {
            const lastLocation = {lat: pos.coords.latitude, lng: pos.coords.longitude};
            setCurrentLocation(lastLocation);
            console.log("Start Timer location", lastLocation);
            
            // Log activity directly with expireTime and location (don't rely on state)
            const activityType = currentUser.workingAlone ? 'refresh' : 'checkin';
            await logActivity(activityType, {expireTime, location: lastLocation});
            
            firestore.collection('users').doc(currentUser.id).set({workingAlone: true, 
                                                                    deadline: fsDeadline,
                                                                    lastCheckinTime: serverTimestamp(),
                                                                    lastLocation: lastLocation,
                                                                    lastLocationUpdate: serverTimestamp(),
                                                                    app_version: APP_VERSION,
                                                                    app_platform: APP_PLATFORM
                                                                },
                                                                {merge: true})
                                                            .then(async () => {
                                                                // Schedule BEFORE hiding the overlay, so the
                                                                // "do not close the app" warning actually covers
                                                                // this call. Native already did; web did not.
                                                                await scheduleNotificationsHelper();
                                                                setCheckingIn(false);
                                                            })
                                                            .catch((error) => {console.log('Error updating user',error); setCheckingIn(false);});
           
        }
        //if we can't get location, still update firestore, but without location data
        const checkinLocationError = async (err) => {
            notification.open({
                message: "Unable to Get Your Location",
                description: "You may have disabled location services on this device",
                icon: <MdLocationOff />,
                duration: 0,
              
            });
            
            console.warn(`ERROR(${err.code}): ${err.message}`);
            
            // Log activity directly with expireTime (don't rely on state)
            const activityType = currentUser.workingAlone ? 'refresh' : 'checkin';
            await logActivity(activityType, {expireTime});
            
            firestore.collection('users').doc(currentUser.id).set({workingAlone: true, 
                deadline: fsDeadline,
                lastCheckinTime: serverTimestamp(),
                app_version: APP_VERSION,
                app_platform: APP_PLATFORM
            },
            {merge: true})
        .then(async () => {
            // Schedule before hiding the overlay (see note above).
            await scheduleNotificationsHelper();
            setCheckingIn(false);
        })
        .catch((error) => {console.log('Error updating user',error); setCheckingIn(false);});
        }
        //console.log("retrieving location");
        
        if (Capacitor.getPlatform() === 'web') {
            navigator.geolocation.getCurrentPosition(checkinLocationSuccess, checkinLocationError, {timeout: 10000, maximumAge: 0, enableHighAccuracy:true});
        } else {
            //we are on native - use optimized flow that prioritizes safety-critical operations
            const activityType = currentUser.workingAlone ? 'refresh' : 'checkin';
            console.log("activity type:", activityType);
            
            // STEP 1: Log check-in immediately (critical for activity log)
            const logRef = await logActivity(activityType, {expireTime});
            console.log("Activity logged immediately, docRef:", logRef?.id);
            
            // STEP 2: Start timer immediately (critical for safety - timer must start)
            // Update user document with workingAlone: true and deadline WITHOUT waiting for location
            await firestore.collection('users').doc(currentUser.id).set({
                workingAlone: true, 
                deadline: fsDeadline,
                lastCheckinTime: serverTimestamp(),
                app_version: APP_VERSION,
                app_platform: APP_PLATFORM
            }, {merge: true});
            console.log("Timer started - user document updated with workingAlone: true and deadline");
            
            // STEP 3: Schedule notifications immediately (critical for safety - contacts must be alerted)
            await scheduleNotificationsHelper();
            console.log("Notifications scheduled - cloud function called");
            
            // STEP 4: Update UI state immediately
            setCurrentUser((p) => ({...p, workingAlone: true, deadline: fsDeadline}));
            setCheckedIn(true);
            
            // STEP 5: Hide loading spinner - critical operations are complete!
            // Timer is started, notifications are scheduled, activity is logged
            setCheckingIn(false);
            console.log("Critical operations complete - spinner hidden. Location fetch continues in background.");
            
            // STEP 6: Fetch location in background (non-blocking, nice-to-have)
            // This continues after the spinner is hidden, so user can close app if needed
            if (nativeLocationEnabled) {
                startTracking(currentUser.tracking_accuracy);
                
                // Give the tracking a moment to initialize before requesting position
                await new Promise(resolve => setTimeout(resolve, 1000));
                
                try {
                    // Increased timeout to 20 seconds - GPS cold fix can take time on some devices
                    const location = await getLocationWithTimeout(20000);
                    console.log("Got location for check-in (background):", location);
                    
                    // Update the log entry with location if successful
                    await updateLogWithLocation(logRef, location);
                    setCurrentLocation(location);
                    
                    // Update user document with location (adds location to existing workingAlone: true)
                    await firestore.collection('users').doc(currentUser.id).set({
                        lastLocation: location,
                        lastLocationUpdate: serverTimestamp()
                    }, {merge: true});
                    console.log("Location updated in background");
                } catch (locationError) {
                    // Location failed or timed out - that's okay, critical operations already complete
                    console.log("Location fetch failed or timed out (non-critical):", locationError.message);
                    notification.open({
                        message: "Location Not Available",
                        description: "Your check-in was recorded, but we couldn't get your location. This may be due to poor reception or location services being disabled.",
                        icon: <MdLocationOff />,
                        duration: 8,
                    });
                }
            } else {
                // Location not enabled at all - show warning with suggestion
                notification.open({
                    message: "Location Services Disabled",
                    description: "Your check-in was recorded without location. For safety, please enable 'Always' location access in your device settings.",
                    icon: <MdLocationOff />,
                    duration: 0,
                });
            }
        }
    }

  
    const stopTimer = async () => {
        
        setDeactivating(true);
        //setDeadline(null);
        //setCheckedIn(false);
        //setTimeExceeded(false);
        

        //get location for log
        const deactivateLocationSuccess = async (pos) => {
            const lastLocation = {lat: pos.coords.latitude, lng: pos.coords.longitude};
            setCurrentLocation(lastLocation);
            console.log("Stop Timer location", lastLocation);
            // Log directly with the location we already have. This used to set a
            // flag and wait for an effect on currentLocation to write the log, but
            // currentLocation is Recoil state and propagates on its own schedule --
            // when it landed before the flag, the effect saw no flag and the
            // Deactivate row was silently never written (~20% of web deactivates).
            logActivity('deactivate', lastLocation);

            firestore.collection('users').doc(currentUser.id).set({workingAlone: false, 
                                                                   reminder_count: null,
                                                                   expired_count: null,
                                                                   lastLocation: lastLocation,
                                                                   lastLocationUpdate: serverTimestamp()
                                                                },
                                                                {merge: true})
                                                            .then(() => { setDeactivating(false);})
                                                            .catch((error) => {console.log('Error updating deactivated user',error)});
            
        }
        //if we can't get location, still update firestore, but without location data
        const deactivateLocationError = async (err) => {
            notification.open({
                message: "Unable to Get Your Location",
                description: "You may have disabled location services on this device",
                icon: <MdLocationOff />,
                duration: 0,
                
            });
            
            console.warn(`ERROR(${err.code}): ${err.message}`);
                logActivity('deactivate');
            
            firestore.collection('users').doc(currentUser.id).set({workingAlone: false, 
                reminder_count: null,
                expired_count: null,
            },
            {merge: true})
            .then(() => { setDeactivating(false);})
            .catch((error) => {console.log('Error updating deactivated user',error)});
        }

        if (Capacitor.getPlatform() === 'web') {
            //web code
            navigator.geolocation.getCurrentPosition(deactivateLocationSuccess, deactivateLocationError, {timeout: 10000, maximumAge: 0, enableHighAccuracy:true});
        } else {
            //native code
            if (nativeLocationEnabled) {
                
                //get current position for log
                const deactivateLocation = await getCurrentPosition();
                //stop background tracking
                stopTracking();
                logActivity('deactivate',deactivateLocation);
            } else {
                logActivity('deactivate');
            }
        }

        firestore.collection('users').doc(currentUser.id).set({workingAlone: false, 
            reminder_count: null,
            expired_count: null,
        },
        {merge: true})
        .then(() => { setDeactivating(false);})
        .catch((error) => {console.log('Error updating deactivated user',error)});

        

        /* if (!currentUser.emergencyBeacon) {
            stopWatchingPosition(watchId);
        }  */

        console.log("running clear queue");
        const clearResponse = await callClearPendingUserNotifications({user_id: currentUser.id});
        console.log("Clear Pending Response:",clearResponse);
        //setCurrentUser(p => ({...p, workingAlone:false}));
        
    }

    const timeExpired = () => {
        setTimeExceeded(true);
    }

    const toggleEmergency = async () => {
        setEmergencyActive(p => !p);
        setCurrentUser(p => ({...p, emergencyBeacon:!emergencyActive}))
        
        //schedule emergency notification
        let messageData = {
            notificationType: 'emergency',
            workalone_user_id: currentUser.id,
            workalone_user_first_name: currentUser.first_name,
            workalone_user_last_name: currentUser.last_name,
            group_id: currentUser.group_id,
            body: `${currentUser.first_name} ${currentUser.last_name} activated their emergency beacon!`, 
            title: 'Work Alone EMERGENCY'
        }

        if (!emergencyActive) {
            //user is activating beacon
            console.log("Activating Emergency Beacon");
            if (Capacitor.getPlatform() !== 'web') {
                //native code - use reliable flow that logs immediately
                
                // Log emergency activation immediately (don't wait for location)
                const logRef = await logActivity('emergencyActivate');
                console.log("Emergency activation logged immediately, docRef:", logRef?.id);
                
                if (nativeLocationEnabled) {
                    startTracking("high");
                    
                    // Give the tracking a moment to initialize before requesting position
                    await new Promise(resolve => setTimeout(resolve, 1000));
                    
                    // Try to get location and update the log
                    try {
                        const location = await getLocationWithTimeout(20000);
                        console.log("Got location for emergency:", location);
                        await updateLogWithLocation(logRef, location);
                        setCurrentLocation(location);
                        
                        await firestore.collection('users').doc(currentUser.id).set({
                            emergencyBeacon: true, 
                            emergencyBeaconActivatedTime: serverTimestamp(),
                            lastLocation: location,
                            lastLocationUpdate: serverTimestamp()
                        }, {merge: true});
                    } catch (locationError) {
                        console.log("Location fetch failed for emergency:", locationError.message);
                        notification.open({
                            message: "Location Not Available",
                            description: "Your emergency alert was sent, but location couldn't be determined. Emergency contacts have still been notified.",
                            icon: <MdLocationOff />,
                            duration: 8,
                        });
                        
                        await firestore.collection('users').doc(currentUser.id).set({
                            emergencyBeacon: true, 
                            emergencyBeaconActivatedTime: serverTimestamp()
                        }, {merge: true});
                    }
                } else {
                    notification.open({
                        message: "Location Services Disabled",
                        description: "Your emergency alert was sent without location. For safety, please enable 'Always' location access in your device settings.",
                        icon: <MdLocationOff />,
                        duration: 0,
                    });
                    
                    await firestore.collection('users').doc(currentUser.id).set({
                        emergencyBeacon: true, 
                        emergencyBeaconActivatedTime: serverTimestamp()
                    }, {merge: true});
                }
                
                try {
                    const response = await Axios.post(`https://us-central1-${projectId}.cloudfunctions.net/sendNotificationsFromScheduler`,messageData);
                } catch(error) {
                    console.log("sending Emergency Message error");
                }
            } else {

                //web code
                const emergencyLocationSuccess = async (pos) => {
                    const lastLocation = {lat: pos.coords.latitude, lng: pos.coords.longitude};
                    console.log("Emergency Beacon Location", lastLocation);
                    
                    await firestore.collection('users').doc(currentUser.id).set({emergencyBeacon: true, emergencyBeaconActivatedTime: serverTimestamp(), lastLocation, lastLocationUpdate: serverTimestamp()},{merge: true});
                    logActivity('emergencyActivate',lastLocation);
                    try {
                        const response = await Axios.post(`https://us-central1-${projectId}.cloudfunctions.net/sendNotificationsFromScheduler`,messageData);
                    } catch(error) {
                        console.log("sending Emergency Message error");
                    }
                
                }
                const emergencyLocationError = async (err) => {
                    console.warn(`ERROR(${err.code}): ${err.message}`);
                    notification.open({
                        message: "Unable to Get Your Location",
                        description: "Your emergency alert will still be sent without location. You may have disabled location services on this device",
                        icon: <MdLocationOff />,
                        duration: 0,
                      
                    });
                    await firestore.collection('users').doc(currentUser.id).set({emergencyBeacon: true, emergencyBeaconActivatedTime: serverTimestamp()},{merge: true});
                    logActivity('emergencyActivate');
                    try {
                        const response = await Axios.post(`https://us-central1-${projectId}.cloudfunctions.net/sendNotificationsFromScheduler`,messageData);
                    } catch(error) {
                        console.log("sending Emergency Message error");
                    }
                }
                navigator.geolocation.getCurrentPosition(emergencyLocationSuccess, emergencyLocationError, {timeout: 10000, maximumAge: 0, enableHighAccuracy:true});
            } //web only code
        
        } else {
            //user is deactivating beacon
            await firestore.collection('users').doc(currentUser.id).set({emergencyBeacon: false }, {merge:true});
            
            if (Capacitor.getPlatform() !== 'web') {
                if (nativeLocationEnabled) {
                    let deactivateLocation = await getCurrentPosition();
                    logActivity('emergencyDeactivate',deactivateLocation);
                    stopTracking();
                } else {
                    logActivity('emergencyDeactivate');
                }
                
            } else {
                //web code
                logActivity('emergencyDeactivate');
            }
            callClearPendingUserEmergencyNotifications({user_id: currentUser.id});
            /* if (!currentUser.workingAlone) {
                stopWatchingPosition(watchId);
            } */
            
        }
        


    }

    const handleCheckinFrequencyClicked = () => {
        if (!currentUser.workingAlone) {
            setShowCheckinModal(true);
        }
    }

    
    return (
        <>
        {/* Loading overlay for check-in process */}
        {checkingIn && (
            <div className="checking-in-overlay">
                <div className="checking-in-spinner"></div>
                <div className="checking-in-text">
                    <LoadingOutlined style={{marginRight: 8}} />
                    Starting timer and getting your location...
                </div>
                <div style={{marginTop: 10, fontSize: 14, color: '#666'}}>
                    Please wait, do not close the app
                </div>
            </div>
        )}
        <CheckinFrequencyForm visible={showCheckinModal} onClose={() => setShowCheckinModal(false)} />
        <Row justify="center" align="middle" style={{height: '60vh'}} >
        <Col  style={{width: 350}}>
            { timeExceeded ? 
                <div className="blink-me" style={{textAlign: 'center', fontSize: 30, marginBottom:20}}>
                    <WarningTwoTone twoToneColor="#E03A3F"/> Time Exceeded!
                </div>
            :
            null
            }
            {/* <div>Lat: {location.lat} Lng: {location.lng}</div>
            <div>Location Changed {locationChangedCounter} times</div> */}
            { checkedIn ? 
                <><div style={{textAlign: 'center'}}>
                    
                    <div style={{fontSize: 30, lineHeight: 1}}>Please Check In Before {deadline.format("h:mm a")}</div>
                    <Countdown title="" value={deadline} format="H:mm:ss" valueStyle={{fontSize: 60}}  onFinish={timeExpired}/>
                </div>
                <Button size="large" disabled={deactivating || checkingIn} loading={checkingIn} type="primary" onClick={startTimer} style={{width:'100%', height: 50, marginBottom: 40}}><GoLocation style={{marginRight:5,}} /> {checkingIn ? 'Checking In...' : 'Check In'}</Button>
                <Button size="large"  loading={deactivating} onClick={stopTimer}     style={{width:'100%', height: 50}}>{deactivating ? "Deactivating" : "Deactivate"}</Button>
                </>
                
            : 
            <Button size="large" type="primary" disabled={checkingIn} loading={checkingIn} onClick={() => confirmBeforeStart(startTimer)} style={{width:'100%', height: 50}}> <GoLocation style={{marginRight:5,}} /> {checkingIn ? 'Starting...' : 'Begin Working Alone'}</Button>
            }
            <div onClick={handleCheckinFrequencyClicked} 
                 style={{width:'100%', textAlign: 'center', marginTop:10, cursor:'pointer'}}
            >
                <IoIosPulse /> Every {currentUser.checkin_frequency} Minutes
            </div>
            {/* Version is shown on the Diagnostics tab (Settings.js), not here. */}

            

        </Col>
        </Row>

        <Row type="flex" justify="center" align="bottom" style={{height: '20vh'}}>
            <Col>
            <div style={{textAlign:'center'}} >
            <label>
                
                <Switch 
                    onChange={() => confirmBeforeStart(toggleEmergency)} 
                    checked={emergencyActive}
                    uncheckedIcon={
                                    <div
                                        style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        textAlign: "left",
                                        height: "100%",
                                        fontSize: 15,
                                        marginLeft:-225,
                                        paddingRight: 2
                                        }}
                                    >
                                    <GoLocation style={{marginRight:5,}} />Emergency&nbsp;Beacon
                                    </div>
                                    }
                    checkedIcon={
                        <div className="blink-me"
                                        style={{
                                        color: "white",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        textAlign: "left",
                                        height: "100%",
                                        fontSize: 15,
                                        marginLeft:150,
                                        paddingRight: 2
                                        }}
                                    >
                                    <span style={{fontSize:35}}><AlertFilled twoToneColor="#E03A3F" style={{marginRight:10, marginBottom:10}}/></span>Emergency&nbsp;Beacon&nbsp;Active
                                    </div>
                                }
                    height={60}
                    width={350}
                    onColor="#E03A3F"
                    onHandleColor="#FFF"
                    activeBoxShadow="0px 0px 1px 2px rgba(0, 0, 0, 0.2)"   
                 />
            </label>
            </div>
            </Col>
        </Row>
        </>
        
    )
}

export default Checkin;

